<!--
	描述：通用的键值对录入方式弹窗
-->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body" :msvalue='msStyle'>
		<datePicker ref="datepicker" :initDate='new Date()' @selectDate="selectDate1($event)" type="day"></datePicker>
		<datePicker ref="datepicker2" :initDate='new Date()' @selectDatetime="selectDate2($event)" type="dayTime"></datePicker>
		
		<tabWithDataList ref='tabDatas' v-if='nowTabData' class="tab-class" @confirm='confirmTab' @saveTemplate='saveTabTemplate'
		 @deleteTab='deleteTabTemplate' @update='updateTabItem' :dataList='nowTabData.dataList' :title='nowTabData.title'
		 :label='nowTabData.tablabel' :defaultValue='result[nowTabData.pkid]' :defaultList='nowTabData.defaultList' :tabList='nowTabData.tabList'
		 :slotType='nowTabData.slotType'></tabWithDataList>
		 
		<template slot="title">
			{{title}}
		</template>
		<template v-for="(item,index) in rows">
			<div class="flexdiv" v-if="item.type == 1" :key="item.pkid">
				<span :style='labelStyle(item)'>{{item.name}}</span>
				<textarea :name="item.pkid" v-model="result[item.pkid]" placeholder="最大长度:1024字符" maxlength="1024"></textarea>
			</div>
			<div class="flexdiv" v-else-if="item.type == 2" :key="item.pkid">
				<span :style='labelStyle(item)'>{{item.name}}</span>
				<input type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
				 :name="item.pkid" :id="item.pkid" v-model="result[item.pkid]" />
			</div>
			<div class="flexdiv" v-else-if="item.type == 3" :key="item.pkid">
				<span :style='labelStyle(item)'>{{item.name}}</span>
				<input type="number" :name="item.pkid" :id="item.pkid" v-model="result[item.pkid]" />
			</div>
			<div class="flexdiv" v-else-if="item.type == 4" :key="item.pkid">
				<span :style='labelStyle(item)'>{{item.name}}</span>
				<input @click.stop="nowPkid = item.pkid;$refs.datepicker.show()" type="text" :name="item.pkid" :id="item.pkid"
				 :value="getDateInfo(result[item.pkid])" readonly />
			</div>
			<div class="flexdiv" v-else-if="item.type == 5" :key="item.pkid">
				<span :style='labelStyle(item)'>{{item.name}}</span>
				<input @click.stop="nowPkid = item.pkid;$refs.datepicker2.show()" type="text" :name="item.pkid" :id="item.pkid"
				 :value="getDateTimeInfo(result[item.pkid])" readonly />
			</div>
			<div class="flexdiv" v-else-if="item.type == 6" :key="item.pkid">
				<!-- 布尔型 -->
				<span :style='labelStyle(item)'>{{item.name}}</span>
				<booleanCheckBox class="booleanCheckBox" v-model="result[item.pkid]" :key="item.pkid"></booleanCheckBox>
			</div>
			<div class="flexdiv" v-else-if="item.type == 7" :key="item.pkid">
				<!-- 下拉选择 -->
				<span :style='labelStyle(item)'>{{item.name}}</span>
				<singleSelection class="singleSelection" :nameKey="item.nameKey" :list='item.dataList' :autoCheck='item.defaultValue'
				 @checkItem="check7Item(item.pkid, $event)" :key="item.pkid"></singleSelection>
			</div>
			<div class="flexdiv" v-else-if="item.type == 8" :key="item.pkid">
				<!-- 下拉选择 -->
				<span :style='labelStyle(item)'>{{item.name}}</span>
				<!-- <input type="text" :name="item.pkid" id="item.pkid" value="提交图片功能未开放" readonly /> -->
				<!-- <input type="text" :name="item.pkid" :id="item.pkid" v-model="result[item.pkid]"> -->
				<img :id="item.pkid" :src="imageSrc(item)" @click="nowPkid = item.pkid;$refs.imagePicker[0].click()" title="上传图片">
				<input type="file" @change="getFile" accept="image/png, image/jpeg" style="display: none;" ref="imagePicker" />
			</div>
			<div class="flexdiv" v-else-if="item.type == 9" :key="item.pkid">
				<!-- 下拉选择 -->
				<span :style='labelStyle(item)'>{{item.name}}</span>
				<!-- <input type="text" :name="item.pkid" id="item.pkid" value="控件选择功能未开放" readonly /> -->
				<img :src="getPicByName('/chat/ico_pdf.svg')" @click="nowPkid = item.pkid;$refs.pdfPicker[0].click()" title="上传文件">
				<input type="file" @change="getFile" accept="application/pdf" style="display: none;" ref="pdfPicker" />
				<span :id="item.pkid">{{resourceName(item)}}</span>
			</div>
			<div class="flexdiv" v-else-if="item.type == 10" :key="item.pkid">
				<!-- 下拉选择 -->
				<span :style='labelStyle(item)'>{{item.name}}</span>
				<multipleSelection :key="item.pkid" class="multipleSelection" :nameKey="item.nameKey" :autoCheck="item.defaultValue?item.defaultValue:[]"
				 :list='item.dataList' @checkItem="result[item.pkid] = $event"></multipleSelection>
			</div>
			<div class="flexdiv" v-else-if="item.type == 11" :key="item.pkid">
				<!-- 要移除 -->
				<div class="flexTreeDiv">
					<!-- 下拉选择 -->
					<div class="tree-label">
						<span :style='labelStyle(item)'>{{item.name}}</span>
						<div style="display: flex;align-items: center;" v-if="item.radioList">
							<div v-for="(radio,index) in item.radioList" style="margin-left: .1rem;" :key="index">
								<input type="radio" :name="item.pkid" @change="changeRadio(item,radio)" :value="radio.value" v-model="radioData[item.pkid]" />
								<span>{{radio.name}}</span>
							</div>
						</div>
						<img @click="deleteNode(index,item)" v-show="item.showClose" style="height: .15rem;width: .15rem;" :src="getPicByName('wedoButton/close.png')" />
					</div>
					<div style='width:100%' class="flexdiv">
						<input :style="getTreeLabel" type="text" :name="item.pkid" :id="item.pkid" :value="getlabel(result[item.pkid],item)"
						 :key='item.pkid' readonly @click="showTreeFunction(item.pkid)" style="border: 1px solid #BABEC2;" />
						<div :style="getTreeStyle" v-show='showTheTree(item.pkid)'>
							<demandTree v-if="item.treeType=='demand'" :id="item.pkid+'tree'" :dataList="getTreeList(item,false)" :key='item.pkid'
							 @checkItem="checkTreeItem(item,index,$event,item.checkTreeFc)" :groupCheckAble='getGroupCheckAble(item)'
							 :autoSelectMethod="getAutoSelectMethod(item)" :isSameItem="getIsSameItem(item)" :getIDMethod="getIDMethod(item)"
							 :multiSelect="getMultiSelect(item)">
							</demandTree>
							<orderGroupTree :ref="item.pkid" :key='item.pkid' :id="item.pkid+'tree'" v-else :dataList="getTreeList(item,false)"
							 @checkItem="checkTreeItem(item,index,$event,item.checkTreeFc)" :multiSelect="getMultiSelect(item)"
							 :groupCheckAble='getGroupCheckAble(item)' :autoSelectMethod="getAutoSelectMethod(item)" :isSameItem="getIsSameItem(item)"
							 :getIDMethod="getIDMethod(item)" :defaultValue='item.defaultValueList' :loadMore="getLoadMore(item)"
							 :loadMoreMethod="()=>{$refs.body.close() ;item.loadMoreMethod()}">
							</orderGroupTree>
						</div>
					</div>
				</div>
			</div>
			<div class="flexdiv" v-else-if="item.type == 12" :key="item.pkid">
				<!-- 下拉选择 -->
				<span :style='labelStyle(item)'>{{item.name}}</span>
				<div @click='check12Type(item)' class='flex-scroll hideBar' v-if='showTabListLabel(item)'>
					<!-- <div :key='tindex' v-if="!item.slotType=='dataList' || !item.slotType==undefined" v-for='(tabitem,tindex) in result[item.pkid].selectList'>{{item.getLabel?item.getLabel(tabitem):tabitem}}</div> -->
					<div class="divo" v-if="item.slotType=='dataList' || item.slotType==undefined">
						<el-time-select
						class="el-date-editor"
							v-model="startTime"
							format='HH:mm'  
    						value-format="HH:mm"
							placeholder="选择上班时间">
							</el-time-select>
							<el-time-select
						class="el-date-editor"
							v-model="endTime"
							format='HH:mm'  
    						value-format="HH:mm"
							placeholder="选择下班时间">
							</el-time-select>
					</div>
					<div class="div" v-if='item.slotType=="twice"'>{{get12TypeLabel(item)}}</div>
				</div>
				<!-- <div @click='check12Type(item)' class='tab-label' v-else>{{item.label?item.label:'请选择'}}</div> -->
				<div @click='item.label == "选择上班时间" ? "" : check12Type(item)' v-else>
					<div v-if="item.label == '选择上班时间'" class='flex-scroll hideBar'>
						<div class="divo">
						<el-time-picker
						class="el-date-editor"
							v-model="startTime"
							format='HH:mm'  
    						value-format="HH:mm"
							placeholder="选择上班时间">
							</el-time-picker>
							<el-time-picker
						class="el-date-editor"
							v-model="endTime"
							format='HH:mm'  
    						value-format="HH:mm"
							placeholder="选择下班时间">
							</el-time-picker>
							</div>
					</div>
					<div v-else class='tab-label'>{{item.label?item.label:'请选择'}}</div>
				</div>
			</div>
			<div class="flexdiv" v-else :key="item.pkid">
				<span :style='labelStyle(item)'>{{item.name}}</span>
				<input type="text" :name="item.pkid" :id="item.pkid" v-model="result[item.pkid]" />
			</div>
		</template>
		<div v-for="(addP,ind) in addPointList" :key="ind" @click="addPoint(addP)" class="point-add">
			{{addP.addPointLabel}} +
		</div>
	</dialogBody>
</template>

<script>
	import dialogBody from './dialogBody.vue'
	import multipleSelection from '@/components/module/selection/multipleSelection.vue'
	import booleanCheckBox from '@/components/module/selection/booleanCheckBox.vue'
	import singleSelection from '@/components/module/selection/singleSelection.vue'
	import dateButton from '@/components/module/universal/dateButton.vue'
	import datePicker from '@/components/module/universal/datePicker.vue'
	import orderGroupTree from '@/components/module/tree/orderGroupTree.vue'
	import demandTree from '@/components/module/tree/demandTree.vue'
	import resourcesStore from '@/cache/resourcesStore.js'
	import enumStore from '@/cache/enumStore.js'
	import tabWithDataList from '@/components/module/tab/tabWithDataList.vue'
import debugPageVue from '../../../page/debug/debugPage.vue'
	export default {
		components: {
			tabWithDataList,
			dialogBody,
			booleanCheckBox,
			singleSelection,
			multipleSelection,
			dateButton,
			datePicker,
			orderGroupTree,
			demandTree
		},
		props: {},
		data() {
			return {
				addPointLabel: "节点",
				result: {},
				callback: undefined,
				title: '',
				rows: [],
				nowPkid: '',
				showTree: {},
				treeDatas: [],
				radioData: {},
				defaultIndex: 0,
				addPointList: [],
				nowTabData: undefined,
				oldResult: {},
				startTime:'',
				endTime:'',
			}
		},
		computed: {
			get12TypeLabel() {
				return item => {
					var res = this.result;
					return item.getLabel ? item.getLabel(res[item.pkid]) : res[item.pkid]
				}
			},
			showTabListLabel() {
				return item => {
					if (isempty(item.slotType) || item.slotType == 'dataList') {
						return this.result[item.pkid] && this.result[item.pkid].selectList.length
					} else {
						return this.result[item.pkid] && this.result[item.pkid].groupName
					}
				}
			},
			labelStyle() {
				return item => {
					return item.labelStyle ? item.labelStyle : {
						color: 'black'
					}
				}
			},
			msStyle() {
				return {
					// 'background-color': this.getColorById('dialogTreeBG'),
					'border': '1px solid #D6D6D6',
					'min-height': '1rem',
					'max-height': '4rem',
					'padding': '.1rem',
					'overflow-y': 'auto',
				}
			},
			getDateInfo() {
				return item => {
					var info = ''
					try {
						info = item.formatByDate()
					} catch (e) {}
					return info
				}
			},
			getDateTimeInfo() {
				return item => {
					var info = ''
					try {
						info = item.formatByTime()
					} catch (e) {}
					return info
				}
			},
			getColorById() {
				return id => {
					return resourcesStore.getters.getColorById(id)
				}
			},
			getPicByName() {
				return name => {
					return resourcesStore.getters.getResourcesByName(name)
				}
			},
			showAddButton() {
				if (Object.keys(this.showTree).length > 0) {
					return true
				} else {
					return false
				}
			},
			getTreeLabel() {
				return {
					'border': ' .01rem solid #CCCCCC',
					'border-radius': ' .05rem',
					'margin': ' 0 0.1rem',
					'padding': ' .02rem .05rem',
					'line-height': ' .25rem',
					// 'width': ' 1.88rem',
				}
			},
			getTreeStyle() {
				return {
					'border-radius': ' .05rem',
					'position': ' relative',
					'background-color': '#9ca1a4',
					'width': 'calc(100% - 0.2rem)',
					'margin': ' 0.01rem .1rem',
				}
			},
			getlabel() {
				return (result, item) => {
					if (this.getMultiSelect(item)) {
						return item.format ? item.format(result, this.radioData, item) : result.map(data => data.name).join(',')
					} else {
						return result ? (item.format ? item.format(result) : result) : ''
					}
				}
			},
			getLoadMore() {
				return item => {
					if (item.getLoadMore instanceof Function) {
						return item.getLoadMore(item, this.radioData)
					} else {
						if (!isempty(item.loadMore) && !isempty(item.radioList) && item.loadMore[this.radioData[item.pkid]] != undefined) {
							return item.loadMore[this.radioData[item.pkid]]
						} else {
							return item.loadMore
						}
					}
				}

			},

			getAutoSelectMethod() {
				return item => {
					if (item.getAutoSelectMethod instanceof Function) {
						return item.getAutoSelectMethod(item, this.radioData)
					} else {
						if (!isempty(item.autoSelectMethod) && !isempty(item.radioList) && item.autoSelectMethod[this.radioData[
								item.pkid]] != undefined) {
							return item.autoSelectMethod[this.radioData[item.pkid]]
						} else {
							return item.autoSelectMethod
						}
					}
				}

			},
			getIsSameItem() {
				return item => {
					if (item.getIsSameItem instanceof Function) {
						return item.getIsSameItem(item, this.radioData)
					} else {
						if (!isempty(item.isSameItem) && !isempty(item.radioList) && !isempty(item.isSameItem[this.radioData[item.pkid]])) {
							return item.isSameItem[this.radioData[item.pkid]]
						} else {
							return item.isSameItem
						}
					}
				}

			},
			getMultiSelect() {
				return item => {
					if (item.getMultiSelect instanceof Function) {
						return item.getMultiSelect(item, this.radioData)
					} else {
						if (!isempty(item.multiSelect) && !isempty(item.radioList) && !isempty(item.multiSelect[this.radioData[item.pkid]])) {
							return item.multiSelect[this.radioData[item.pkid]]
						} else {
							return item.multiSelect
						}
					}
				}

			},
			getGroupCheckAble() {
				return item => {
					if (item.getIDMethods instanceof Function) { //子类自定义获取groupCheckAble的方法
						return item.getGroupCheckAble(item, this.radioData)
					} else {
						if (!isempty(item.groupCheckAble) && !isempty(item.radioList) && !isempty(item.groupCheckAble[this.radioData[
								item.pkid]])) {
							return item.groupCheckAble[this.radioData[item.pkid]]
						} else {
							return item.groupCheckAble
						}
					}
				}

			},
			getIDMethod() {
				return item => {
					if (item.getIDMethods instanceof Function) { //子类自定义获取treeList的方法
						return item.getIDMethods(item, this.radioData)
					} else {
						if (!isempty(item.getIDMethod) && !isempty(item.radioList) && !isempty(item.getIDMethod[this.radioData[item.pkid]])) {
							return item.getIDMethod[this.radioData[item.pkid]]
						} else {
							return item.getIDMethod
						}
					}
				}
			},
			getTreeList() {
				return (item, isUpdate) => {
					if (item.getTreeList instanceof Function) { //子类自定义获取treeList的方法
						return item.getTreeList(item, this.radioData)
					} else {
						if (!isempty(item.radioList) && (item.treeList[this.radioData[item.pkid]] instanceof Array)) {
							return item.treeList[this.radioData[item.pkid]]
						} else {
							return item.treeList
						}
					}
				}
			},
			
			imageSrc(item){
				return item => {
					let pkid = item.defaultValue
					var path = resourcesStore.getters.getDownLoadPath([pkid])
					return getValueIfNoNull(path[pkid], resourcesStore.getters.getResourcesByName('/chat/ico_image.svg'))  
				}
			},
			
			resourceName(item){
				return item => {
					if(item.defaultValue){
						let pkid = item.defaultValue
						var path = resourcesStore.getters.getDownLoadPath([pkid])
						if(path[pkid]){
							let pathList = path[pkid].split("/")
							return pathList[pathList.length-1]
						}
					}
				}
			}
		},
		watch: {
			result: {
				handler(nv, ov) {
					if (debugPage.$router.history.current.path != '/archivesType') {
						return
					}
					if (nv.valueType instanceof Object && nv.valueType.value == 7 && isempty(nv.enumCode)) {
						var index = -1
						this.rows.forEach((d, i) => {
							if (d.pkid == 'enumCode') {
								index = i
							}
						})
						if (index > -1) {
							return
						}
						this.rows.forEach((d, i) => {
							if (d.pkid == 'valueType') {
								index = i + 1
							}
						})
						if (index != -1) {
							this.rows.splice(index, 0, {
								name: '枚举字典',
								pkid: 'enumCode',
								type: 7,
								nameKey: "enumname",
								defaultValue: 0,
								dataList: enumStore.getters.getEnumTree
							})


						}
					} else if (nv.valueType instanceof Object && nv.valueType.value != 7) {
						var index = -1
						this.rows.forEach((d, i) => {
							if (d.pkid == 'enumCode') {
								index = i
							}
						})

						if (index != -1) {
							delete this.result.enumCode
							this.rows.splice(index, 1)
						}
					}

					if (nv.valueType instanceof Object &&
						this.oldResult.valueType instanceof Object &&
						nv.valueType.value != this.oldResult.valueType.value) {
						delete this.result.defaultValue
						var index = -1
						this.rows.forEach((d, i) => {
							if (d.pkid == 'enumCode') {
								index = i
							}
						})

						if (index > -1) { //枚举

							if (this.result.enumCode == undefined) {
								return
							}
							var next = this.result.enumCode.next
							index = -1
							this.rows.forEach((d, i) => {
								if (d.pkid == 'defaultValue') {
									index = i
								}
							})
							if (index > -1) {
								var temp = this.rows[index]
								temp = Object.assign(temp, {
									dataList: next,
									nameKey: 'itemText',
									defaultValue: 0,
									type: 7
								})
								this.$set(this.result, 'defaultValue', next[0])
								this.$set(this.rows, index, temp)
							}
						} else { //其他

							var valueType = this.result.valueType
							if (valueType == undefined) {
								return
							}
							index = -1
							this.rows.forEach((d, i) => {
								if (d.pkid == 'defaultValue') {
									index = i
								}
							})
							if (index > -1) {
								var temp = this.rows[index]
								delete temp.nameKey
								delete temp.defaultValue
								delete temp.dataList
								this.$set(this.rows[index], 'type', valueType.value)
							}
						}
					} else if (nv.enumCode instanceof Object &&
						this.oldResult.enumCode instanceof Object &&
						nv.enumCode.id != this.oldResult.enumCode.id) {
						var index = -1

						if (this.result.enumCode == undefined) {
							return
						}
						var next = this.result.enumCode.next

						index = -1
						this.rows.forEach((d, i) => {
							if (d.pkid == 'defaultValue') {
								index = i
							}
						})
						if (index > -1) {
							var temp = this.rows[index]
							temp = Object.assign(temp, {
								dataList: next,
								nameKey: 'itemText',
								defaultValue: 0,
								type: 7
							})
							this.$set(this.result, 'defaultValue', next[0])
							this.$set(this.rows, index, temp)
						}
					}
					this.oldResult = copy(nv)
					this.openAgain()
				},
				deep: true
			},
		},
		mounted() {
		},
		methods: {
			// 						getTreeList(item, isUpdate) {
			// 							if (item.getTreeList instanceof Function) {
			// 								return item.getTreeList(item, this.radioData)
			// 							} else {
			// 								if (!isempty(item.radioList)) {
			// 									return item.treeList[this.radioData[item.pkid]]
			// 								} else {
			// 									return item.treeList
			// 								}
			// 							}
			// 						},
			check7Item(pkid, data) {
				this.$set(this.result, pkid, data) // result[nowPkid] = $event;
			},
			selectDate1(data) {
				this.$set(this.result, this.nowPkid, data) // result[nowPkid] = $event;
				this.$refs.datepicker.hide()
			},
			selectDate2(data) {
				this.$set(this.result, this.nowPkid, data) // result[nowPkid] = $event;
				this.$refs.datepicker2.hide()
			},
			confirmTab(item) {
				this.$set(this.result, this.nowTabData.pkid, item)
				// this.result[this.nowTabData.pkid] = item
				this.nowTabData = undefined
			},
			updateTab(item) { //更新rows   item为拼装好的nomallInputDialogCloumns
				for (var i = 0, len = this.rows.length; i < len; i++) {
					var temp = this.rows[i]
					if (temp.pkid == item.pkid) {
						this.rows[i] = item
						delete this.result[item.pkid]
						this.nowTabData = undefined
						this.openTabAgain()
						return
					}
				}
			},
			updateTabItem(item) {
				if (this.nowTabData.update instanceof Function) {
					// this.nowTabData.update(item, this.nowTabData, this.updateTab)
				}
			},
			// 			addTabItem(item) {
			// 				if (this.nowTabData.addGroup instanceof Function) {
			// 					this.nowTabData.addGroup(item, this.nowTabData, this.updateTab)
			// 				}
			// 			},
			deleteTabTemplate(item) {
				this.nowTabData.deleteTemplate(item, this.nowTabData, this.updateTab)
			},
			saveTabTemplate(item) {
				this.nowTabData.saveTemplate(item, this.nowTabData, this.updateTab)
			},
			check12Type(item) {
				if(item.name != '上班时间'){
					this.nowTabData = item
				setTimeout(() => {
					this.$nextTick(() => {
					this.$refs.tabDatas.show = !this.$refs.tabDatas.show
					})
				}, 100)
				}
			},
			autoSelectMethod(item) {
				if (this.treeDatas[this.defaultIndex] && this.treeDatas[this.defaultIndex].processorId == item.id) {
					this.defaultIndex++
					return true
				} else {
					return false
				}
			},
			changeRadio(item, radio) {
				this.result.radioData[item.pkid] = radio.value
				this.result.radioData[item.pkid] = radio.value
				this.$refs[item.pkid][0].setNowCheckItem(undefined)
				this.openAgain()
			},

			showTheTree(pkid) {
				return this.showTree[pkid] ? this.showTree[pkid] : false
			},
			showTreeFunction(pkid) {
				this.$set(this.showTree, pkid, !this.showTree[pkid])
				// document.getElementById(pkid + 'tree').style.display = pl ? '' : 'none'
			},
			addPoint(data) {
				var maxpoint = 0
				var maxItem = {}
				this.rows.forEach(item => {
					if (item.pointGroup == data.pointGroup) { //item.type == 11 &&
						item.addPointLabel ? this.addPointLabel = item.addPointLabel : ''
						if (item.point > maxpoint) {
							maxItem = item
						}
					}
				})
				var copyItem = {}
				Object.assign(copyItem, maxItem)
				copyItem.point = maxItem.point + 1
				copyItem.name = this.addPointLabel + copyItem.point
				copyItem.pkid = data.pointGroup + copyItem.point
				copyItem.nameKey = data.pointGroup + copyItem.point
				var oldres = copyItem.type == 11 ? [] : ''
				this.result[copyItem.pkid] = oldres
				if (copyItem.radioList) {
					if (isempty(this.result.radioData)) {
						result.radioData = {}
					}
					this.result.radioData[copyItem.pkid] = copyItem.radioList[0].value
					this.$set(this.radioData, copyItem.pkid, copyItem.radioList[0].value)
				}
				this.rows.push(copyItem)
				this.openAgain()
			},
			sortPoint() {
				var count = 1
				for (var i = 0, len = this.rows.length; i < len; i++) {
					var data = this.rows[i]
					if (data.point) {
						var oldres = this.result[data.pkid]
						data.point = count
						data.name = this.addPointLabel + count
						data.pkid = data.pointGroup + count
						data.nameKey = data.pointGroup + count
						this.result[data.pkid] = oldres
						count++
					}
				}
			},
			deleteNode(index, item) {
				if (item.point == 1) {
					this.$dialogMethod.showMessage('必须有一个节点')
					return
				}
				for (var i = 0, len = this.treeDatas.length; i < len; i++) {
					if ((this.treeDatas[i] ? JSON.stringify(this.treeDatas[i]) : undefined) === (this.result[item.pkid] ? JSON.stringify(
							this.result[item.pkid]) : '')) {
						this.treeDatas.splice(i, 1)
						break
					}
					// 					if (this.treeDatas[i].id === (this.result[item.pkid] ? this.result[item.pkid].id : '')) {
					// 						this.treeDatas.splice(i, 1)
					// 						break
					// 					}
				}
				this.rows.splice(index, 1)
				delete this.result[item.pkid]
				delete this.result.radioData[item.pkid]
				delete this.radioData[item.pkid]
				this.sortPoint()
				this.openAgain()
			},
			// 当前的row item index 树选中的item item传入的function
			checkTreeItem(item, index, treeNode, fc) {
				if (fc instanceof Function) {
					var value = fc(item, index, treeNode)
					this.$set(this.result, item.pkid, value)
				} else {
					this.$set(this.result, item.pkid, treeNode)
				}
				this.treeDatas[(item.point - 1)] = treeNode
			},
			confirm() {
				//debugger
				var shouleClose = true
				// let selectList = []
				// selectList.push(this.startTime,this.endTime)
				// let aa = {
				// 	tab: undefined,
				// 	selectList: selectList
				// }
				this.$set(this.result, 'startTime', this.startTime)
				this.$set(this.result, 'endTime', this.endTime)
				// console.log(this.result)
				if (this.callback != undefined) {
					//先校验不能为空的部分
					for (var i = 0, len = this.rows.length; i < len; i++) {
						var item = this.rows[i]
						if (item.nullable == false && this.result[item.pkid] == undefined) {
							this.$dialogMethod.showMessage(item.name+" 不能为空!")
							return
						}
					}
					shouleClose = this.callback(this.result)
				}
				if (shouleClose != false) {
					this.$refs.body.close()
					this.result = {}
				}
			},
			cancel() {
				this.$refs.body.close()
			},
			openTabAgain() {
				this.defaultIndex = 0
				for (var i = 0, len = this.rows.length; i < len; i++) {
					var item = this.rows[i]
					if (item.type == 12) {
						this.result[item.pkid] = item.defaultValue
					}
				}
				this.$refs.body.open()
			},
			openAgain() {
				this.defaultIndex = 0
				this.$refs.body.open()
			},
			open(title, rows, callback) {
				var result = {}
				this.treeDatas = []
				//设置默认值
				for (var i = 0, len = rows.length; i < len; i++) {
					var item = rows[i]
					if (item.type == 4 || item.type == 5) {
						if (isempty(item.defaultValue)) {
							result[item.pkid] = undefined
						} else {
							var a = typeof item.defaultValue == 'string' ? new Date(item.defaultValue) : item.defaultValue instanceof Date ?
								item.defaultValue : new Date()
							var time = a.getTime()
							result[item.pkid] = isNaN(time) ? new Date() : a
						}
					} else {
						result[item.pkid] = item.defaultValue
					}
					if (item.point != undefined) {
						if (isempty(this.addPointList.find(p => {
								return item.pointGroup == p.pointGroup
							}))) {
							this.addPointList.push(item)
						}
					}
					if (item.type == 11) {
						this.treeDatas.push(item.defaultValue)
						this.$set(this.showTree, item.pkid, false)

						if (item.radioList) {
							if (isempty(result.radioData)) {
								result.radioData = {}
							}
							result.radioData[item.pkid] = item.radioList[0].value
							this.$set(this.radioData, item.pkid, item.radioList[0].value)
						}
					}
				}
				if (!this.startTime && !this.endTime && rows[0] != undefined) {
					this.startTime = rows[0].workTime
                    this.endTime = rows[1].workTime  
				}
				this.result = result
				this.title = title
				this.rows = rows
				this.defaultIndex = 0
				this.callback = callback
				this.$refs.body.open()
			},
			
			getFile(event) {
				var file = event.target.files[0]
				var formData = new FormData()
				// 向 formData 对象中添加文件
				formData.append('file', file)
				formData.append("type", resourcesStore.state.fileTypeToTypeEnum[file.type])
				this.$api.resourcesApi.uploadByBytes(formData, respon => {
					if(this.$refs.imagePicker){
						this.$api.resourcesApi.findResourcesById(respon.pkid, res => {
							let imageSrc = DWSystemSetting.downloadUrl + res.urlPath + res.resourceName
							document.getElementById(this.nowPkid).src = imageSrc
						})
					}
					else if(this.$refs.pdfPicker){
						document.getElementById(this.nowPkid).innerText = respon.resourceName
					}
					this.$set(this.result, this.nowPkid, respon.pkid)
					
				}, respon => {
					this.$dialogMethod.showMessage("上传失败!")
				})
			},
		}
	}
</script>
<style scoped>
	.point-add {
		margin-left: .5rem;
		font-size: .1rem;
	}

	.point-add:hover {
		color: #0092DC;
	}

	.flex-cloum {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}

	.tab-label {
		background-color: white;
		border: .01rem solid #CCCCCC;
		border-radius: .05rem;
		margin: 0 .1rem;
		padding: .02rem .05rem;
		height: .25rem;
		line-height: .25rem;
		font-size: .14rem;
		color: black;
	}

	.flex-scroll {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-flow: wrap;
		margin: 0 .1rem;
		padding: .02rem .05rem;
		/* height: 0.36rem;
		overflow-y: scroll; */
	}

	.flex-scroll .div {
		background-color: white;

		color: black;
		width: 1rem;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		margin: 0.05rem .1rem;
		border: .01rem solid #CCCCCC;
		border-radius: .05rem;
		padding: 0.02rem 0.05rem;
		font-size: .14rem;
		font-family: "times new roman", "黑体", serif;
		height: 0.2rem;
		line-height: 0.2rem;
		text-align: center;
	}

	.flex-scroll .divo .el-date-editor{
		    width: 200px;
    		margin: 0.05rem .1rem;
	}

	.flexdiv {
		/* margin: .1rem 0;
		display: flex;
		align-items: center;
		justify-content: center; */
		margin: .1rem 0;
		display: flex;
		flex-direction: column;
	}

	.tree-label {
		display: flex;
		align-items: center;
		padding: 0 .1rem;
	}

	.tree-label>img {
		margin: 0 .1rem;
	}

	.flexTreeDiv {
		width: 100%;
		margin: .1rem 0;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
	}

	.flexTreeDiv>span {
		line-height: .3rem;
		width: 1rem;
		padding: 0 0.1rem;
		text-align: left;
	}

	.flexdiv>span {
		line-height: .3rem;
		padding: 0 0.1rem;
		text-align: left;
	}

	.flexdiv>input {
		border: .01rem solid #CCCCCC;
		border-radius: .05rem;
		margin: 0 .1rem;
		padding: .02rem .05rem;
		line-height: .25rem;
	}
	
	.flexdiv>img{
		margin: 0 .1rem;
		width: 200px;
	}

	.flexdiv>textarea {
		border: .01rem solid #CCCCCC;
		border-radius: .05rem;
		margin: 0 .1rem;
		padding: .02rem .05rem;
		line-height: .2rem;
		height: 1rem;
		resize: none;
		width: 93.33%;
	}

	.booleanCheckBox,
	.singleSelection {
		width: 2rem;
		margin: 0 .1rem;
		padding: .02rem 0;
	}

	.multipleSelection {
		margin: 0 .1rem;
		padding: .02rem .05rem;
		line-height: .25rem;
		width: 1.88rem !important;
	}

	.dateInfo {
		display: inline-block;
		font-size: .16rem;
		border: .01rem solid #CCCCCC;
		border-radius: .05rem;
		margin: 0 .1rem;
		padding: .02rem .05rem;
		line-height: .25rem;
		height: .25rem;
	}

	.tab-class {
		position: fixed;
		top: -0.1%;
		left: -0.5%;
		z-index: 99;
	}
	
	
	>>>.datepicker{
		left: 20%;
		top: 6%;
		bottom: auto;
	}
</style>
